module.exports = __webpack_public_path__ + "media/step2_animation.9f4f25c7.webm";